module.exports = __webpack_public_path__ + "static/img/clients-icon-18.ad56bc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients-icon-18.png
// module id = 58
// module chunks = 0